'use strict';
import axios from 'axios';
import ENV from '../environtment'

const baseUrl = ENV.api
const costumHeader = ENV.costumHeader

const actions = {
  getChartData(context, params = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/history/listchartbycategory`
        const result = await axios.get(url, {
          ...costumHeader('Get Chart History', 4),
          params,
        })
        if (result) if (result.data) if (result.data.code == 200) return resolve(result.data.data)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve([])
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve([])
      }
    })
  },
  getChartDataAttendance(context, body = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/history/listchartattendance`
        const result = await axios.post(url, body, {
          ...costumHeader('Get Chart History Attendance', 4),
        })
        if (result) if (result.data) if (result.data.code == 200) return resolve(result.data.data)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve([])
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve([])
      }
    })
  },
  getChartDataAttendancePerCompany(context, params = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/history/pc/listchart`
        const result = await axios.get(url, {
          ...costumHeader('Get Chart History Attendance Per Company', 4),
          params,
        })
        if (result) if (result.data) if (result.data.code == 200) return resolve(result.data.data)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve([])
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve([])
      }
    })
  },
}

export default { actions }